/* eslint-disable no-undef */
/* eslint-disable no-console */
import axios from "axios";
import { captureException } from "@sentry/react";
import { IGNORE_PRIVATE_PRODUCT_APIS } from "../constants/app-constants";

import { proxy } from "valtio/vanilla";
import { X_COUNTRY_CODE, X_VEHICLE_TYPE } from "../constants/api-constants";
import authRefresh from "../utils/helpers/auth-refresh";

export const proxyAuthState = proxy({
    accessToken: "",
    expiresIn: 300,
    isLoggedIn: true
}) || {};

const DEBUG = process.env.NODE_ENV === "development2";

let BASE_API_URL = "https://user-auth-service.qac24svc.dev";
let X_COUNTRY = X_COUNTRY_CODE.AU;
switch (process.env.HOST_ENV) {
case "QA":
    BASE_API_URL = "https://user-authentication-service-au.qac24svc.dev/";
    X_COUNTRY = X_COUNTRY_CODE.AU;
    break;
case "LNOD":
    BASE_API_URL = "https://user-auth-service.qac24svc.dev";
    X_COUNTRY = X_COUNTRY_CODE.AU;
    break;
case "STAGING":
    BASE_API_URL = "https://stage-user-authentication-service-au.qac24svc.dev/";
    X_COUNTRY = X_COUNTRY_CODE.AU;
    break;
case "PRODUCTION":
    BASE_API_URL = "https://au-oauth.cars24.com.au/";
    X_COUNTRY = X_COUNTRY_CODE.AU;
    break;
default: break;
}

/* Create axios instance */
const api = axios.create({
    baseURL: BASE_API_URL,
    headers: {
        "Content-Type": "application/json",
        X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
        X_COUNTRY
    },
    withCredentials: true
});

// Request Interceptor which handles token refresh pre and post token expiry
api.interceptors.request.use((config) => authRefresh(config, api, proxyAuthState), (error) => {
    if (DEBUG) {
        console.error("✉️ ", error);
    }
    return Promise.reject(error);
});

/**
 * Passes response.data to services.
 * In dev, intercepts response and logs it into console for dev
 */
api.interceptors.response.use((response) => {
    if (DEBUG) { console.debug("📩 ", response); }
    return response;
}, (error) => {
    if (!IGNORE_PRIVATE_PRODUCT_APIS.includes(error.config.url)) {
        captureException(error);
    }
    if (error.response && error.response.data) {
        if (DEBUG) { console.error("Error: ", error.response.data); }
        return Promise.reject({...error.response.data, httpErrorStatus: error.response.status});
    }
    if (DEBUG) { console.error("📩 ", error); }
    return Promise.reject(error);
});

export default api;

